import { createReducer } from '@reduxjs/toolkit'

import { CreateReducer } from 'redux/utils'

import { changeFilterItems, deleteFilter, updateFilter } from './filter.actions'
import { findFilterIndex } from './filter.utils'

import type { FilterState } from '.'

export const filterDefaultState: FilterState = {
  filterItems: [],
}

export const filterReducer: CreateReducer<FilterState> = (sliceName, initialState) =>
  createReducer(
    {
      ...filterDefaultState,
      ...initialState,
    },
    builder => {
      builder
        .addCase(changeFilterItems(sliceName), (state, { payload }) => {
          state.filterItems = payload
        })
        .addCase(updateFilter(sliceName), (state, { payload }) => {
          const index = findFilterIndex(state)(payload)
          if (index === undefined) return
          state.filterItems[index] = {
            ...state.filterItems[index],
            ...payload,
          }
        })
        .addCase(deleteFilter(sliceName), (state, { payload }) => {
          const index = findFilterIndex(state)(payload)
          if (index === undefined) return
          state.filterItems.splice(index, 1)
        })
    },
  )
